// Per-device настройки плеера в localStorage. Обёрнуто в try-catch — как в auth/storage.ts
// (приватный режим бросает на доступе к localStorage). Ключи с общим префиксом `podpipe.`.

import { PLAYBACK_RATES } from './constants'

const RATE_KEY = 'podpipe.playback_rate'
const AUTOPLAY_KEY = 'podpipe.autoplay_next'

export function loadPlaybackRate(): number {
  try {
    const value = Number(localStorage.getItem(RATE_KEY))
    return (PLAYBACK_RATES as readonly number[]).includes(value) ? value : 1
  } catch {
    return 1
  }
}

export function savePlaybackRate(rate: number): void {
  try {
    localStorage.setItem(RATE_KEY, String(rate))
  } catch {
    // приватный режим — игнорируем
  }
}

// По умолчанию автоплей следующего включён: выключенным считается только явное 'false'.
export function loadAutoplayNext(): boolean {
  try {
    return localStorage.getItem(AUTOPLAY_KEY) !== 'false'
  } catch {
    return true
  }
}

export function saveAutoplayNext(enabled: boolean): void {
  try {
    localStorage.setItem(AUTOPLAY_KEY, String(enabled))
  } catch {
    // приватный режим — игнорируем
  }
}
